module.exports = "/lucky-balls/img/drum/drum_loop_016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_016.png
// module id = 1031
// module chunks = 0